module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome/welcome.component.css
// module id = ./src/app/welcome/welcome.component.css
// module chunks = main